import { Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";

import { axiosInstance } from "../../utils/axios-instance";

import { useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// import { GeneralTextInput } from "../Custom-Forms/General-Text-Input";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { EnterNewPasswordSubmission } from "./Enter-New-Password-Submission";

import { deleteTokens } from "../Sign-Out/Delete-Tokens";
import { resetJobData } from "../../store/slices/job-data-slice";
import { resetApplications } from "../../store/slices/application-slice";
import { resetSignIn } from "../../store/slices/signed-in-slice";

import { selectSignIn } from "../../store/slices/signed-in-slice";

import {toast} from 'react-toastify';

export const EnterNewPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);
    const [searchParams] = useSearchParams();
    const [submitted, setSubmitted] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const ToastID = React.useRef(null)

    // Get token in url '?token={token}&id={id}'
    const token = searchParams.get("token");
    // Get id in url '?token={token}&id={id}'
    const id = searchParams.get("id");

    // Make sure id is a valid UUID
    let reg =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    // Make sure password is NOT empty and is required on submission
    const enterNewPasswordValidationSchema = Yup.object({
        password: Yup.string()
            .min(8, "Password minimum length is 8 characters")
            .matches(
                /([a-z]{1,})/,
                "Password must include one lowercase letter"
            )
            .matches(
                /([A-Z]{1,})/,
                "Password must include one uppercase letter"
            )
            .matches(/([0-9]{1,})/, "Password must include a number")
            .matches(
                /([<>,./?'"{}[\]\\|!@#$%^&*()_+=-]{1,})/,
                "Password must include a special character."
            )
            .required("A Valid Password is Required"),
        passwordCheck: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords need to match")
            .required("Passwords must match")
    });

    // If the id or token in the URL param is empty, navigate to a different page
    useEffect(() => {
        if (id === null || token === null) {
            navigate("/");
        }
    });

    // // If user is signed in,
    // // redirect to the home page
    // useEffect(() => {
    //     if (isSignedIn) {
    //         navigate("/");
    //     }
    // }, [dispatch, isSignedIn, navigate]);

    return (
        <>
            <>
                <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                    <h1>Enter new Password</h1>
                    <Row className="card-background card-font">
                        <Formik
                            initialValues={{
                                password: "",
                                passwordCheck: ""
                            }}
                            validationSchema={enterNewPasswordValidationSchema}
                            onSubmit={async (values, { setStatus }) => {
                                ToastID.current = toast.loading(`Attempting to Reset Password`, {theme: "colored", containerId:"root", autoClose: "5000"} )
                                if (!reg.test(id)) {
                                    setStatus({ error: false });
                                }

                                try {
                                    const response = await axiosInstance({
                                        method: "post",
                                        url: `/reset-password`,
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        data: {
                                            password: values.password,
                                            token: token,
                                            id: id
                                        }
                                    });
                                    toast.update(ToastID.current , {render: `Successfully Changed Password`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                    setStatus({ error: false });
                                    setTimeout(() => {
                                        navigate("/signin");
                                    }, 2500);
                                    setSubmitted(true);

                                    // signout all other people
                                    await deleteTokens()
                                    dispatch(resetJobData());
                                    dispatch(resetApplications());
                                    dispatch(resetSignIn());
                                    // setTimeout(() => {
                                    //     navigate('/signin');
                                    // }, 2500);
                                } catch (error) {
                                    toast.update(ToastID.current , {render: `Failed to Reset Password. Please Try Again Later.`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root"})
                                    setStatus({ error: true });
                                    console.error(error);
                                    return Promise.reject(error);
                                }
                            }}
                        >
                            <Form>
                                <Row>
                                    <Row>
                                        <p className="text-danger">
                                            On Successful Password Change, you will be signed out on all devices.
                                        </p>
                                    </Row>
                                    {!submitted && (
                                        <>
                                            <Row className="mx-0">
                                                <GeneralTextAreaField
                                                    label="Password:"
                                                    className="form-control"
                                                    component="input"
                                                    name="password"
                                                    type={
                                                        showPassword ? "text" : "password"
                                                    }
                                                    rows="1"
                                                    placeholder="Enter New Password"
                                                    autoComplete="new-password"
                                                />
                                            </Row>
                                            <Row className="mx-0 mb-2 ">
                                                <GeneralTextAreaField
                                                    label="Confirm Password:"
                                                    className="form-control"
                                                    name="passwordCheck"
                                                    component="input"
                                                    type={
                                                        showPassword ? "text" : "password"
                                                    }
                                                    rows="1"
                                                    placeholder="Confirm New Password"
                                                    autoComplete="new-password"
                                                />
                                            </Row>
                                        </>
                                    )}
                                </Row>
                                <EnterNewPasswordSubmission props={{showPassword, setShowPassword}}/>
                            </Form>
                        </Formik>
                    </Row>
                </Container>
            </>
        </>
    );
};
